import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Paragraph from '../../Paragraph';
import Button from '../../Button';
import Heading from '../../Heading';
import { renderField } from '../../Inputs';
import { Row } from '../../Register/Scaffold';
import Progress from '../../Progress';

const validate = (valueSet) => {
  const values = valueSet;
  const errors = { assessment: {} };

  if (!values.assessment) values.assessment = {};
  if (!values.assessment.curr_act_times) errors.assessment.curr_act_times = 'Please enter your activity level';

  return errors;
};

class CurrentAct extends React.PureComponent {
  render() {
    const { prevPage, handleSubmit } = this.props;

    return (
      <Row>
        <Progress step="activity" />
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="100" height="100" />
        </Paragraph>
        {/* <Heading classes="header-text green" center><span id="register5">GET ACTIVE</span></Heading> */}
        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text" center><strong>How many days per week are you currently doing some form of physical activity that raises your heart rate for half an hour or more?</strong></Paragraph>
          <Field
            name="exercise"
            type="radiogroup"
            params={{ dataKey: 'numDaysWeek', name: 'exercise' }}
            component={renderField}
            centered
          />
          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={prevPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

CurrentAct.propTypes = {
  prevPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(CurrentAct);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/CurrentAct.jsx